<div class="container-lead">
  <div>
    @for (item of list; track item.key) {
      <div class="click-css" [mat-dialog-close]="item.key">
        {{ item.title }}
      </div>
    }
  </div>

  <app-button btnType="stroked" [mat-dialog-close]="false">{{ 'cancel' | translate }}</app-button>
</div>
